// Modified InvestorScreen component
import { Button, DatePicker, Form, Input, message, Select } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { SiMicrosoftexcel } from "react-icons/si";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import Loading from "../../components/loading";
import API from "../../config/api";
import { DELETE, GET, POST, PUT } from "../../utils/apiCalls";
import PageHeader from "../routes/pageHeader";
import DataTable from "./components/dataTable";
import EditVcModal from "./components/edit";
import Meetings from "./components/meetings";
import "./styles.scss";

import type { Key } from "react";
import BulkEmail from "./components/bulkEmail";

function InvestorScreen() {
  const location = useLocation();
  const navigate = useNavigate();
  const query = new URLSearchParams(location.search);
  const Events = useSelector((state: any) => state.Events);
  const user = useSelector((state: any) => state.User.user);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [isLoading2, setIsLoading2] = useState(true);
  const [isLoading3, setIsLoading3] = useState(false);
  const [data, setData] = useState([]);
  const [meta, setMeta] = useState<any>({});

  const [selectedItem, setSelectedItem] = useState<any>({});
  const [openMeetings, setOpenMeetings] = useState(false);
  const [editVc, setEditVc] = useState(false);
  const [roomData, setRoomData] = useState([]) as any;

  const [data1, setData1] = useState<any>(1);
  // temp test
  const [bulkMode, setBulkMode] = useState(false);
  const [bulkEmailOpen, setBulkEmailOpen] = useState(false);
  const [selectedVcIds, setSelectedVcIds] = useState<Key[]>([]);
  const [selectAllEvent, setSelectAllEvent] = useState(false);

  const closeBulkMode = () => {
    setBulkMode(false);
    setSelectedVcIds([]);
    setSelectAllEvent(false);
  };

  const startBulkEmail = () => {
    setBulkMode(true);
    setSelectedVcIds([]);
    setSelectAllEvent(false);
  };

  const continueBulkEmail = () => {
    if (!selectAllEvent && !selectedVcIds.length) {
      message.warning("Please select at least one Corporate");
      return;
    }

    setBulkEmailOpen(true);
  };
  useEffect(() => {
    closeBulkMode();
    setBulkEmailOpen(false);
  }, [Events?.defult?.id]);
  // temp test end

  useEffect(() => {
    getData();
    getMeetingRooms();
  }, [data1]);

  // Updated changeParams function
  const changeParams = (data: any) => {
    // If sorting parameters aren't explicitly provided, preserve current ones from URL
    const sortField = data?.sortField !== undefined ? data.sortField : query.get("sortField");
    const sortOrder = data?.sortOrder !== undefined ? data.sortOrder : query.get("sortOrder");

    const queryParams = [
      { key: "query", value: data?.query !== undefined ? data.query : (data?.val && query.get("query")) },
      {
        key: "startDate",
        value: data?.startDate !== undefined ? data.startDate : (data?.val && query.get("startDate")),
      },
      { key: "roomId", value: data?.roomId !== undefined ? data.roomId : (data?.val && query.get("roomId")) },
      { key: "attended", value: data?.attended !== undefined ? data.attended : (data?.val && query.get("attended")) },
      { key: "sortField", value: sortField },
      { key: "sortOrder", value: sortOrder },
    ]
      .filter((param) => param.value !== null && param.value !== undefined && param.value !== "" && param.value !== "null")
      .map((param) => `&${param.key}=${param.value}`)
      .join("");

    const baseUrl = `/company/investors?page=${data?.page || query.get("page") || 1
      }&limit=${data?.pageSize || query.get("limit") || 10}`;

    navigate(`${baseUrl}${queryParams}`);
    setData1(data1 + 1);
  };

  // Updated getData function
  const getData = async () => {
    try {
      setIsLoading2(true);
      const params = {
        eventId: Events?.defult?.id,
        ...(query.get("query") && { query: query.get("query") }),
        ...(query.get("startDate") && { startDate: query.get("startDate") }),
        ...(query.get("page") && { page: query.get("page") }),
        ...(query.get("limit") && { take: query.get("limit") }),
        ...(query.get("roomId") && { roomId: query.get("roomId") }),
        ...(query.get("attended") && { attended: query.get("attended") }),
        ...(query.get("sortField") && { sortField: query.get("sortField") }),
        ...(query.get("sortOrder") && { sortOrder: query.get("sortOrder") }),
        ...(query.get("nomeeting") && { nomeeting: query.get("nomeeting") }),
        ...(query.get("noroom") && { noroom: query.get("noroom") }),
      };
      const url = API.INVESTORS_LIST_SEARCH;
      const res: any = await GET(url, params);
      if (res.status) {
        setData(res.data);
        setMeta(res.meta);
      } else {
        message.error("Failed to fetch investors data.");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      message.error("An error occurred while fetching investors.");
    } finally {
      setIsLoading2(false);
      setLoading(false);
    }
  };

  // Updated generateExcel function
  const generateExcel = async () => {
    try {
      setIsLoading3(true);

      const params = {
        ...(query.get("query") && { query: query.get("query") }),
        ...(query.get("startDate") && { startDate: query.get("startDate") }),
        ...(query.get("roomId") && { roomId: query.get("roomId") }),
        ...(query.get("attended") && { attended: query.get("attended") }),
        ...(query.get("sortField") && { sortField: query.get("sortField") }),
        ...(query.get("sortOrder") && { sortOrder: query.get("sortOrder") }),
        ...(query.get("noroom") && { noroom: query.get("noroom") }),
        ...(query.get("nomeeting") && { nomeeting: query.get("nomeeting") }),
        eventId: Events?.defult?.id,
      };

      const url = API.INVESTORS_LIST_SEARCH;
      const response: any = await GET(url, params);

      if (response?.status) {
        const formattedData = response.data.map((investor: any, index: number) => {
          let attendees = [];
          if (investor.Attendees && Array.isArray(investor.Attendees)) {
            attendees = investor.Attendees.map(
              (a: any, index: number) =>
                `${index + 1}) FullName: ${a.fullName || ""} | JobTitle: ${a.jobTitle || ""} | Email: ${a.email || ""} | Company: ${a.company || ""}. `
            );
          }

          return {
            No: index + 1,
            Corporate: investor.company,
            "Contact Person": investor.fullname,
            Email: investor.email,
            JobTitle: investor.jobTitle,
            "Meeting Room": investor.meeting_room,
            "Has Meeting": investor.has_meeting ? "Yes" : "No",
            Attendence: investor?.has_attended ? "Attended" : "Not Attended",
            Attendees: attendees.join("\r\n"),
            "Created At": dayjs(investor.createdAt).format("DD MMM YYYY"),
            "Updated At": dayjs(investor.updatedAt).format("DD MMM YYYY"),
            "Profile Link": {
              t: "l",
              v: `${API.WEB_URL}/vc-details/${investor?.uuid}/?event=${Events?.defult?.id}`,
              l: { Target: `${API.WEB_URL}/vc-details/${investor?.uuid}/?event=${Events?.defult?.id}` }
            }
          };
        });

        const worksheet = XLSX.utils.json_to_sheet(formattedData);

        const colWidths = Object.keys(formattedData[0]).map(key => ({
          wch: Math.max(
            key.length,
            ...formattedData.map((row: any) => (row[key] ? row[key].toString().length : 0))
          )
        }));
        worksheet["!cols"] = colWidths;

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        const excelBuffer = XLSX.write(workbook, {
          bookType: "xlsx",
          type: "array",
        });

        const dataBlob = new Blob([excelBuffer], {
          type: "application/octet-stream",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(dataBlob);
        link.download = `Investors-Report-${new Date().toLocaleString()}.xlsx`;
        link.click();
      }
    } catch (err) {
      console.log(err);
      message.error("Couldn't generate Reports");
    } finally {
      setIsLoading3(false);
    }
  };

  const itemMeetings = (value: any) => {
    setSelectedItem(value);
    setOpenMeetings(!openMeetings);
  };

  const editItem = (value: any) => {
    setSelectedItem(value);
    setEditVc(!editVc);
  };
  const getMeetingRooms = async () => {
    try {
      let url = API.ROOMS_PICKER + Events?.defult?.id;
      const response: any = await GET(url, null);
      if (response?.status) {
        setRoomData(response?.data);
      } else {
        setRoomData([]);
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      setIsLoading2(false);
    }
  };

  // Simplified onSortChange in InvestorScreen
  const onSortChange = (field: string | undefined, order: string | undefined) => {
    changeParams({
      sortField: field,
      sortOrder: order,
      page: 1,
    });
  };

  const handleDeleteItem = async (id: any) => {
    try {
      const response: any = await DELETE(API.INVESTORS_DELETE + id);
      if (response?.status) {
        getData();
        message.success("Deleted successfully.");
      } else {
        message.error("Failed to delete.");
      }
    } catch (err) {
      message.error("An error occurred while deleting.");
    }
  };
  const updateAttendance = async (data: {
    id: string;
    has_attended: boolean;
    investor_id: string;
  }) => {
    try {
      const response: any = await PUT(
        `${API.INVESTORS_UPDATE_ATTENDANCE}${data.id}`,
        {
          has_attended: data?.has_attended,
          investor_id: data?.investor_id,
          updated_by: user?.name
        }
      );
      if (response?.status) {
        getData();
        message.success("Attendance updated successfully.");
      } else {
        message.error("Failed to update.");
      }
    } catch (err) {
      message.error("An error occurred while updating attendance.");
    }
  };
  return (
    <div>
      <PageHeader title={"Corporates"}>
        {loading ? null : (
          <Form
            form={form}
            onValuesChange={(_, allData) => {
              // Process startDate if it's a dayjs object
              const processedData = {
                ...allData,
                startDate: allData.startDate ? dayjs(allData.startDate).format("YYYY-MM-DD") : allData.startDate,
                page: 1,
                // IMPORTANT: Preserve existing sorting by explicitly passing current URL params
                sortField: query.get("sortField"),
                sortOrder: query.get("sortOrder"),
              };
              changeParams(processedData);
            }}
            initialValues={{
              query: query.get("query"),
              startDate: query.get("startDate") && dayjs(query.get("startDate")),
              roomId: query.get("roomId"),
              attended: query.get("attended"),
            }}
          >
            <div className="AdminHeader-extra">
              <Form.Item name={"query"} noStyle>
                <Input style={{ width: 200 }} placeholder="Search" allowClear />
              </Form.Item>
              <Form.Item name={"startDate"} noStyle>
                <DatePicker placeholder="Date" style={{ minWidth: 100 }} />
              </Form.Item>
              <Form.Item name={"roomId"} noStyle>
                <Select
                  allowClear
                  placeholder="Room"
                  style={{ minWidth: 150 }}
                  showSearch
                  optionFilterProp="children"
                >
                  {roomData.map((room: any) => (
                    <Select.Option key={room.id} value={room.id}>
                      {room.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item name={"attended"} noStyle>
                <Select
                  allowClear
                  placeholder="Attendance"
                  style={{ minWidth: 150 }}
                >
                  <Select.Option value="true">Attended</Select.Option>
                  <Select.Option value="false">Not Attended</Select.Option>
                </Select>
              </Form.Item>
              {Array.isArray(user.access[Events?.defult?.id]) &&
                user.access[Events?.defult?.id].includes(8) ? null : <>

                {/* test */}
                {!bulkMode ? (
                  <Button onClick={startBulkEmail}>
                    Bulk Email
                  </Button>
                ) : (
                  <>
                    <Button onClick={() => setSelectAllEvent(!selectAllEvent)}>
                      {selectAllEvent ? "All Event Corporates Selected" : "Select All Event Corporates"}
                    </Button>

                    <Button
                      type="primary"
                      onClick={continueBulkEmail}
                      disabled={!selectAllEvent && !selectedVcIds.length}
                    >
                      Continue {selectAllEvent ? "(All Event Corporates)" : `(${selectedVcIds.length})`}
                    </Button>

                    <Button onClick={closeBulkMode}>
                      Cancel
                    </Button>
                  </>
                )}
                {/* test end */}

                <Button type="primary" onClick={() => editItem({})}>
                  ADD Corporate +
                </Button>
                <Button
                  loading={isLoading3}
                  onClick={() => generateExcel()}
                  disabled={Array.isArray(user.access[Events?.defult?.id]) &&
                    user.access[Events?.defult?.id].includes(8)}
                  style={{ padding: 5, background: "#fff", cursor: "pointer" }}
                >
                  EXPORT <SiMicrosoftexcel size={20} color="green" />
                </Button>
              </>
              }

            </div>
          </Form>
        )}
      </PageHeader>
      {loading ? (
        <Loading />
      ) : (
        <DataTable
          data={data}
          meta={meta}
          loading={isLoading2}
          meetings={(data: any) => itemMeetings(data)}
          onPageChange={(page: number, pageSize: number) =>
            changeParams({ page, pageSize, val: true })
          }
          onSortChange={onSortChange}
          sortField={query.get("sortField")}
          sortOrder={query.get("sortOrder")}
          delete={(id: any) => handleDeleteItem(id)}
          updateAttendance={(data: any) => updateAttendance(data)}
          bulkMode={bulkMode}
          selectAllEvent={selectAllEvent}
          selectedVcIds={selectedVcIds}
          setSelectedVcIds={setSelectedVcIds}
        />
      )}
      {openMeetings ? (
        <Meetings
          visible={openMeetings}
          data={selectedItem}
          onClose={() => {
            getData();
            itemMeetings({});
          }}
        />
      ) : null}
      {editVc ? (
        <EditVcModal
          visible={editVc}
          roomData={roomData}
          data={data}
          onClose={() => setEditVc(!editVc)}
          onFinish={() => getData()}
        />
      ) : null}
      <BulkEmail
        open={bulkEmailOpen}
        onClose={() => setBulkEmailOpen(false)}
        onFinish={() => {
          setBulkEmailOpen(false);
          closeBulkMode();
          getData();
        }}
        eventId={Number(Events?.defult?.id)}
        investorIds={selectedVcIds.map(Number)}
        selectAllEvent={selectAllEvent}
      />
      <br />

    </div>
  );
}

export default InvestorScreen;